/*
Poornima 09/19/2022 2700799562 Fixed GAL-127,132,73,60,104 bugs
aditya 09/19/2022 2700799562 Fixed GAL (151,152,153,154)
adityaa 09/21/2022 2700799562 Fixed Global field bugs (GAL-154, 201)
ashraf 09/29/2022 2700799562 fixed bugs on global fields
Poornima 09/29/2022 2700799562 Global field delete usage popup changes
Poornima 09/29/2022 2700799562 Search field list changes
ashraf 09/29/2022 2700799562 fixed style issues in custom windows
sohel 09/30/2022 2700799562 Global Field List ->Fixed Jira bugs
sohel 09/30/2022 2700799562 Global Field List ->Added Copy Functionality(GAL-311) and Tabel Payload Changes.
sohel 09/30/2022 2700799562 Globalfieldlist ->Print Global List payload Changes
Poornima 09/30/2022 2700799562 Fixed GAL-306 bug
sohel 09/30/2022 2700799562 Global Field List ->Export Usage Payload changes and Group Code Dropdown changes
sohel 10/03/2022 2700799562 Global Field ->Category look up Changes and Fixed GAL-343,336 and Download Configuration Payload Changes
ashraf 10/04/2022 2700799562 fixed payload changes for global field, group, fieldlist Api's, alert popup changes
ashraf 10/06/2022 2700799562 fixed global field usage url
dilip 10/10/2022 2700799562 visbility icon changed to Datausage
dilip 10/10/2022 2700799562 changed Visibility To Datausage icon
sohel 10/10/2022 2700799562 Global Field List ->Fixed GAL -455 and 456
sohel 10/11/2022 2700799562 Global Field List ->Download Configuration Usage Payload Changes
sohel 10/14/2022 2700799562 Global Field ->Added Code Comments.
sohel 10/14/2022 2700799562 Global Field ->Added Code Comments Changes
suresh 10/17/2022 2700799562 Design Enhancements in global Field Group, List.
Suresh Peddavoora 10/25/2022 2700799562 Text Fields Alignments Fixes.
Suresh Peddavoora 10/25/2022 2700799562 Table Data Alignments Fixes.
Sohel 10/25/2022  2700799562 Changed label and style add button.
Sohel 10/25/2022  2700799562 reset selected data.
Sohel 10/26/2022  2700799562 field list code changed redirect condition.
Sohel 10/27/2022 3031450488 Integrated get API.
saikrishna 10/29/2022 3031450488 prepopulated FieldListCode
Sohel 10/30/2022 3031450488 Changed Table data render condition.
akhila 10/31/2022 3031450488 fixed loading issue
ashraf 10/31/2022 3031450488 changed add field list button alignment, text
Sohel 11/1/2022 3031450488 reset table search data.
akhila 11/1/2022 3031450488 fixed bug
lalitha 11/01/2022 3031450488 added span element in column link
saikrishna 02/11/2022 3031450488 Fixed fields rendering issue in field list accordion
Prakash Gummala 11/02/2022 3031450488 Fixed Responsiveness for 768px.
saikrishna 11/03/2022 3031450488 changed the paginationOptions
Ashraf 11/02/2022 3031450488 fixed conditional render bug.
Dilip 11/03/2022 3031450488 Added fieldlist code in delete popup
Dilip 11/04/2022 3031450488 Changed message in delete popup
Lalitha 11/04/2022 3031450488 Rename Add/View Field List to Add Field List
Sohel 11/05/2022 3031450488 rename download configuration
saikrishna 11/09/2022 3031450488 Fixed improper fields rendering bug and other page crash bugs
Sohel 11/11/2022 3031450488 Fixed reports field list selection disabled issue
Sohel 11/15/2022 3031450488 Fixed field list selection disabled issue
Sohel 11/15/2022 3031450488 fixed selected field list issue
Sohel 11/15/2022 3031450488 fixed selected field list disabled issue
Sai krishna 11/17/2022 2700271704 Action dropdown -- Validation bug fixes.
Ashraf 11/18/2022 3031450488 resetting rules after field list change
lalitha 11/23/2022 3031450488 fixed table api bug
akhila 11/18/2022 3031450488 Bugfix in table api
Ashraf 11/24/2022 3031450488 Fixed resetting issue
Sohel  12/01/2022  3031450488 Download Configuration Usage changes
Sohel 12/02/2022 3031450488 Global Field List Changes
Sohel 12/03/2022 3031450488 Added Created By and Created Date column
Sohel 12/03/2022 3031450488 Delete Popup Added FieldCode
Sohel 12/03/2022 2700799562 usage title Changes
Poornima 12/05/2022 3031450488 added border bottom to field list code column
lalitha 12/07/2022 3031450488 added Created By payload
Lalitha  12/07/2022 3031450488  Rename Global Field List to Field List
Rajesh 12/08/2022 3031450488 added Field list notes action
akhila 12/08/2022 3031450488 adding session storage for search items
Akhila 12/09/2022 3031450488 fixed session saerch issue
kavya9reddy 12/09/2022 3031450488 Added createdDate in payload
Dilip 12/12/2022 3031450488 changed dialog title of system notes
Ashraf 12/14/2022 3031450488 removed role access
Lalitha 12/15/2022 3031450488 Added Role Base Access
Ashraf 01/02/2022 3031450488 renamed usage header title
Ashraf 01/12/2022 3031450488 conditional renders for audit list
Ashraf 01/13/2023 3031450488 Added Api check for audit list delete
kavyareddy 02/07/2023 3031450488 payload change for createdBy
Rohini 02/09/2023 3031450488 added classnames for the tables
Dilip 02/13/2023 3031450488 payload change for createdBy
suresh peddavoora 02/21/2023 3031450488 new UI changes for texfields and tables alignments
Akhila 02/22/2023 3031450488 Added preview file functionlity in download configuration
Dilip 02/28/2023 3031450488 Fixed Sorting issue
Dilip 02/28/2023 3031450488 payload change
Ravi 03/01/2023 3031450488 Added loader and download toast message for preview File
Akhila 03/01/2023 3031450488 Added loader and download toast message for preview File
T Santosh Kumar 15/03/2023 3031450488 Responsive UI Changes
suresh peddavoora 03/16/2023 3031450488 added dropdown action column for field list
Raghu 03/04/2023 3031450488 added plus icon
Ravi 05/31/2023 3031450488 changed delete popup message
Akhila 06/07/2023 3031450488 added code and description in action
Akhila 06/08/2023 3031450488 created date change to date created field and column
Akhila 07/01/2023 2700799562 field list name change to audit field list
Gireesh 12/11/2023 2692790263 added validation for audit field list code and description in audit field list
*/

import {Button, Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useEffect, useState, useContext, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {tableIcons} from '../../../../../components/TableIcons';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {
  fetchGlobalFieldListUsage,
  fetchSuccess,
  fetchGlobalFieldListData,
  resetGlobalFieldList,
  resetLinkedCatagoriesData,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {httpGet, httpPaginationDelete, httpPaginationPost} from '../../../../../util/Rest';
import {
  printGlobalFieldList,
  resetMessage,
} from '../../../../../redux/reducers/GlobalField/AddFieldList';
import {SuccessSnackbar, ErrorSnackbar} from '../../../../../components/CustomSnackBar';
import {postPrintUsage, resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {useUpdateEffect} from 'react-use';
import OverrideRule from '../../../../../components/OverrideRule';
import SelectTabContextProvider from '../../../../../components/SelectTabContext/SelectTabContext';
import {makeStyles} from '@material-ui/core';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import UsageMessage from '../../../../../util/UsageMessage';
import moment from 'moment';
import DialogBox from '../../../../../components/DialogBox';
import GlobalFieldListSystemNotes from '../AddFieldList/GlobalFieldListSystemNotes';
import {downloadButton} from '../../../../../util/Content';
import {fetchCreatedByDropDownData} from '../../../../../redux/reducers/ReportMaster';
import axios from 'axios';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import PageLoader from '../../../../../components/PageLoader';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
const FieldListSearchTable = ({
  saveData,
  setSaveData,
  setSelectedList,
  selectedList,
  searchData,
  setTabValue,
  submit,
  setSubmit,
  setFieldListRowData,
  setUsage,
  setDeleteUsage,
  usage,
  isDelete,
  setIsDelete,
  userMetrixDelete,
  setUsageState,
  usageState,
  setRowSelected,
  setUserMetrixDelete,
  setIsCopyData,
  StepperFieldList,
  setShowSearch,
  setFieldListCode,
  setFieldList,
  fieldList,
  isReportLoader,
  AuditFieldList,
  deleteSql,
  auditSearchData,
  field,
}) => {
  const tableRef = createRef();
  const queryRef = useRef(null);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [checked, setChecked] = useState();
  const [rows, setRows] = useState(defaultRows);

  const [deleteData, setDeleteData] = useState({});
  const [tstmsg, setToastMsg] = useState('');
  const [deleteError, setDeleteError] = useState(false);
  const [deleteCheckLoading, setDeleteCheckLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [dataCount, setDataCount] = useState('');
  const [printSearch, setPrintSearch] = useState('');
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const [isNote, setIsNote] = useState(false);
  const [notesFieldListCode, setNotesFieldListCode] = useState('');
  const {setGlobalFieldRow} = useContext(SelectTabContextProvider);
  const {searchRecordFormatFieldData} = useSelector(({addRecordFormat}) => addRecordFormat);
  const {
    GlobalFieldListPrintStatus,
    successMsg,
    errorMsg,
    isLoading,
    fieldListDataUsage,
    configurationUrl,
    dockey,
  } = useSelector(({addFieldList}) => addFieldList);
  const {basicInfoData} = useSelector(({addRuleGroup}) => addRuleGroup);
  const {filterRuleGroupData} = useSelector(({addFilterRuleGroup}) => addFilterRuleGroup);
  // const { fieldlListData } = useSelector(({ reportMaster }) => reportMaster);
  const printusage = useSelector(({printusage}) => printusage);
  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Audit Field List']?.['FL'];
  // const disableDelete = roleData?.window?.["Global Fields"]?.["GF"]?.delete;
  // const disableDelete = roleData?.window?.["Field List"]?.["FL"]?.delete;
  const [code, setCode] = useState(fieldList);
  const useStyles = makeStyles((theme) => ({
    'link': {
      // Changed field list code column font color (2700799562)
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const maxSelections = 1;
  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [disbaleRow, setDisableRow] = useState('');
  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);
  const handleSelectionProps = (rowData) => {
    return {
      disabled: !!(checked && checked.length >= maxSelections && !rowData.tableData.checked),
    };
  };

  useEffect(() => {
    if (tableRef?.current && submit) {
      !AuditFieldList && Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
      AuditFieldList && Object.keys(auditSearchData).length > 0 ?
        tableRef.current.onQueryChange() :
        '';
    }
  }, [submit]);

  useEffect(() => {
    if (tableRef?.current && !fieldList) {
      tableRef.current.onQueryChange();
      setChecked([]);
    }
  }, [fieldList]);

  useEffect(() => {
    if (tableRef?.current && code) {
      tableRef.current.onQueryChange();
    }
  }, [code]);
  useEffect(() => {
    if (fieldList) {
      setStatus(true);
    }
  }, [fieldList]);
  // if table data print successfully or error message then reset message after 3sec.(2700799562)
  useEffect(() => {
    if (printusage.errorMsg || printusage.successMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printusage.errorMsg, printusage.successMsg]);

  // global Field Print successfully then reset Data after 3sec(2700799562)
  useEffect(() => {
    if (GlobalFieldListPrintStatus && GlobalFieldListPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [GlobalFieldListPrintStatus]);

  // delete data reset error or sucess toast message after 2.5sec(2700799562)
  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 2500);
    }
  }, [tstmsg, deleteErrorMsg]);

  // if Usage then reset Usage State(2700799562)
  useEffect(() => {
    usageState && setUsageState(false);
  }, []);

  const deletionCheck = (rowData) => {
    setDeleteCheckLoading(true);
    httpGet(`debtor-audit/check/${rowData?.fieldListCode}`)
      .then((response) => {
        if (response?.status === 200 && response?.response?.uses === true) {
          setDeleteCheckLoading(false);
          setDeleteError(response?.response?.message);
          setIsDelete(true);
          // setTimeout(() => {
          //   setDeleteError("")
          // }, 6000);
        } else {
          setDeleteCheckLoading(false);
          setIsDelete(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleDelete = (rowData) => {
    setDisableRow(rowData);
    setDeleteData(rowData);
    if (AuditFieldList) {
      deletionCheck(rowData);
    } else {
      dispatch(fetchGlobalFieldListUsage(rowData.fieldListCode));
      setIsDelete(true);
      setDeleteUsage(true);
    }
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
    setDeleteError('');
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };

  // status is changed Update Table Data(2700799562)
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      dispatch(fetchCreatedByDropDownData('fieldlist'));
      dispatch(fetchCreatedByDropDownData('auditfieldlist'));
      setStatus(false);
    }
  }, [status]);

  // delete Global Field List(2700799562)
  const handleSubmit = () => {
    setStatus(true);
    httpPaginationDelete(
        `globalfield/delete/fieldlist/${deleteData?.fieldListId}/${
        AuditFieldList ? 'AuditField' : 'Global'
        }`,
    )
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setStatus(false);
          dispatch(fetchSuccess(response));
          handleCloseDialog();
          setDeleteError('');
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setStatus(false);
          handleCloseDialog();
          setTimeout(() => {
            dispatch(resetMessage());
          }, 6000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // checking when delete there is usage or not(2700799562)
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldListRowData(deleteData);
      setUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);

      // setTabValue(2);
    } else {
      handleSubmit();
    }
  };
  const columns = [
    {
      title: 'Base Category',
      field: 'baseCategory',
    },
    {
      title: `${AuditFieldList ? 'Audit' : ''} Field List Code`,
      field: 'fieldListCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            // if(rowData?.fieldListCode){
            // dispatch(fetchFieldListData(rowData?.fieldListCode));
            dispatch(fetchGlobalFieldListData(rowData?.fieldListId, AuditFieldList));
            setRowSelected(rowData?.fieldListId);
            if (!StepperFieldList) {
              setTabValue(1);
              setGlobalFieldRow(true);
            } else {
              setShowSearch(true);
            }
            // }
          }}
        >
          {rowData?.fieldListCode}
        </span>
      ),
    },
    {
      title: `${AuditFieldList ? 'Audit' : ''} Field List Description`,
      field: 'fieldListDesc',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
  ];

  useEffect(() => {
    if (fieldList) {
      setCode(fieldList);
    }
  }, [fieldList]);

  // useEffect(() => {
  //   if (fieldlListData?.fieldListCode)
  //     setChecked([{ fieldListCode: fieldlListData?.fieldListCode }]);
  // }, [fieldlListData?.fieldListCode]);

  useEffect(() => {
    if (checked?.length > 0 && checked[0]?.fieldListCode && !AuditFieldList) {
      // dispatch(fetchFieldListData(checked[0]?.fieldListCode));
      dispatch(fetchGlobalFieldListData(checked[0]?.fieldListCode));
    }
  }, [checked]);
  useEffect(() => {
    setIsCopyData && setIsCopyData(false);
    if (!StepperFieldList) {
      dispatch(resetGlobalFieldList());
      dispatch(resetLinkedCatagoriesData());
    }
  }, []);
  const handleNotesDialog = () => {
    setIsNote(false);
  };

  const SearchSessionFieldList = JSON.parse(sessionStorage.getItem('FieldList'));
  const SearchSessionAuditFieldList = JSON.parse(sessionStorage.getItem('AuditFieldList'));

  if (SearchSessionFieldList && !submit && !StepperFieldList && !AuditFieldList) {
    searchData = SearchSessionFieldList;
  }

  if (SearchSessionAuditFieldList && !submit && !StepperFieldList && AuditFieldList) {
    auditSearchData = SearchSessionAuditFieldList;
  }
  const handleEdit = (rowData) => {
    dispatch(fetchGlobalFieldListData(rowData?.fieldListId, AuditFieldList));
    setRowSelected(rowData?.fieldListCode);
    setTabValue(1);
    setGlobalFieldRow(true);
  };
  const handleCopy = (rowData) => {
    setIsCopyData(true);
    // dispatch(fetchFieldListData(rowData?.fieldListCode));
    dispatch(fetchGlobalFieldListData(rowData?.fieldListId, AuditFieldList));
    if (!StepperFieldList) {
      setTabValue(1);
    } else {
      setShowSearch(true);
      setFieldList('');
    }
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    dispatch(fetchGlobalFieldListUsage(rowData?.fieldListCode));
    setFieldListRowData(rowData);
  };
  const handleNotes = (rowData) => {
    setIsNote(true);
    setNotesFieldListCode(rowData);
  };
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Audit Field List'}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleNotesDialog}
        title={`${AuditFieldList ? 'Audit' : ''} Field List System Notes`}
        maxWidth="lg"
        hideFooter={true}
      >
        <GlobalFieldListSystemNotes
          AuditFieldList={AuditFieldList}
          filedListCode={notesFieldListCode}
        />
      </DialogBox>
      {isLoading || (
        <DeleteTableRecordPopup
          open={isDelete}
          dialogClose={handleCloseDialog}
          title={`Delete ${AuditFieldList ? 'Audit' : ''} Field List`}
          value={
            deleteError ? (
              <>
                <div>{deleteError}</div>
                <div className="mt-2">{`Are you sure you want to delete the ${
                  deleteData?.fieldListCode
                } ${AuditFieldList ? 'Audit' : ''} Field List ?`}</div>
              </>
            ) : userMetrixDelete ? (
              <UsageMessage
                value={`${deleteData?.fieldListCode} ${AuditFieldList ? 'Audit' : ''} Field List`}
              />
            ) : (
              `Are you sure you want to delete the ${deleteData?.fieldListCode} ${
                AuditFieldList ? 'Audit' : ''
              } Field List ?`
            )
          }
          handleSubmit={handleDeleteUsage}
          buttonCondition={userMetrixDelete}
        />
      )}

      <OverrideRule
        dialogTitle={`${AuditFieldList ? 'Audit' : ''} Field List Usage`}
        dialogOpen={usage}
        dialogClose={() => setUsage((state) => !state)}
        title={`This ${
          AuditFieldList ? 'Audit' : ''
        } Field List has been used in the following places.`}
        data={fieldListDataUsage?.placeResponse}
        isOverRide={false}
      />
      <Grid item xs={12}>
        <div className="custom-table  custom-toolbar-icons custom-actions-icon  actions-dropdown-table global-field-table tablescroll-block new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isLoading || printusage?.isLoading || isReportLoader || deleteCheckLoading}
            onSelectionChange={(rows, unselected) => {
              if (
                deleteSql &&
                unselected.tableData.checked &&
                unselected.fieldListCode !== filterRuleGroupData.fieldListCode &&
                filterRuleGroupData.isDraft === 'N'
              ) {
                deleteSql.current = [];
                filterRuleGroupData.filterSQLRuleResponse.forEach((el) =>
                  deleteSql.current.push(el.id),
                );
              }
              if (
                Object.keys(basicInfoData)?.length > 0 &&
                deleteSql &&
                unselected.tableData.checked &&
                unselected.fieldListCode !== basicInfoData.fieldListCode &&
                basicInfoData.isDraft === 'N'
              ) {
                deleteSql.current = [];
                basicInfoData?.addRule?.forEach((el) => deleteSql.current.push(el?.ruleId));
              }
              setChecked(rows);
              setFieldListCode && setFieldListCode(rows[0]?.fieldListCode);
              setFieldList && setFieldList(rows[0]?.fieldListCode);
              !rows?.length && dispatch(resetGlobalFieldList());
            }}
            // isLoading={isLoading}
            data={(query) =>
              new Promise((resolve) => {
                const url = `globalfield/search/fieldlist`;
                const data = AuditFieldList ? {...auditSearchData} : {...searchData};
                setFieldListCode && setFieldListCode(data?.fieldListCode);
                const bodyObj = {
                  baseCategory: data?.baseCategory?.categoryCode ?
                    data?.baseCategory?.categoryCode :
                    '',
                  fieldListCode: data?.fieldListCode ? data.fieldListCode : '',
                  fieldListDesc: data?.fieldListDescripton ? data.fieldListDescripton : '',
                  tabType: AuditFieldList ? 'AuditField' : 'Global',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  createdBy: data?.createdBy?.userLoginName ? data?.createdBy?.userLoginName : '',
                  createdDate: data?.createdDate ?
                    moment(data?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  search: query?.search ? query?.search : '',
                };
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (
                  Object.keys(searchRecordFormatFieldData).length > 0 &&
                  searchRecordFormatFieldData.status
                ) {
                  bodyObj['frameWorkType'] = 'Enable';
                }

                if (!data) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newData =
                          data?.length > 0 ?
                            data?.map((i) => {
                              if (i?.fieldListCode === code?.toUpperCase()) {
                                return {
                                  ...i,
                                  tableData: {checked: true},
                                };
                              } else {
                                return {
                                  ...i,
                                };
                              }
                            }) :
                            [];
                        resolve({
                          data: fieldList ? newData : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObject.length === 1);
                        setDataCount(response.data.response.count);
                        setSubmit(false);
                        setPrintSearch(query.search.trim());
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            // actions={[
            //   !StepperFieldList && {
            //     icon: () => (
            //       <>
            //         <Button
            //           type="button"
            //           variant="outlined"
            //           className={`mx-1 search-btn`}
            //           disabled={disable?.add === false}
            //         >
            //           {AuditFieldList ? "Add Audit Field List" : "Add Field List"}
            //         </Button>
            //       </>
            //     ),
            //     disabled: !disable?.add,
            //     isFreeAction: true,
            //     onClick: (event) => {
            //       if (StepperFieldList) {
            //         dispatch(resetMessage());
            //         setShowSearch(true);
            //       } else {
            //         setTabValue(1);
            //       }
            //     },
            //   },
            //   {
            //     icon: () => <EditOutlinedIcon />,
            //     tooltip: "Edit",
            //     hidden: StepperFieldList,
            //     disabled: !disable?.edit,
            //     onClick: (event, rowData) => {
            //       //dispatch(fetchFieldListData(rowData?.fieldListCode));
            //       dispatch(fetchGlobalFieldListData(rowData?.fieldListCode, AuditFieldList));
            //       setRowSelected(rowData?.fieldListCode);
            //       setTabValue(1);
            //       setGlobalFieldRow(true);
            //     },
            //   },
            //   !StepperFieldList && {
            //     icon: () => (
            //       <>
            //         <FileCopyOutlinedIcon className={classes.copyButtonroot} />
            //       </>
            //     ),
            //     tooltip: "Copy",
            //     position: "row",
            //     disabled: !disable?.add,
            //     onClick: (event, rowData) => {
            //       setIsCopyData(true);
            //       //dispatch(fetchFieldListData(rowData?.fieldListCode));
            //       dispatch(fetchGlobalFieldListData(rowData?.fieldListCode, AuditFieldList));
            //       if (!StepperFieldList) {
            //         setTabValue(1);
            //       } else {
            //         setShowSearch(true);
            //         setFieldList("");
            //       }
            //     },
            //   },
            //   {
            //     icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //     tooltip: "Usage",
            //     hidden: StepperFieldList || AuditFieldList,
            //     onClick: (event, rowData) => {
            //       setDeleteUsage(false);
            //       dispatch(fetchGlobalFieldListUsage(rowData?.fieldListCode));
            //       setFieldListRowData(rowData);
            //     },
            //   },
            //   (rowData) => {
            //     return {
            //       icon: () => (
            //         <>
            //           <DeleteOutlineOutlinedIcon />
            //         </>
            //       ),
            //       tooltip:
            //         rowData?.isDefault === "Y" ? "Cannot delete default audit list" : "Delete",
            //       hidden: StepperFieldList,
            //       //disabled: !disableDelete,
            //       disabled: !disable?.delete || rowData?.isDefault === "Y",
            //       onClick: (event, rowData) => {
            //         handleDelete(rowData);
            //       },
            //     };
            //   },
            //   {
            //     icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //     tooltip: `${AuditFieldList ? "Audit" : ""} Field List Notes`,
            //     hidden: StepperFieldList,
            //     onClick: (event, rowData) => {
            //       setIsNote(true);
            //       setNotesFieldListCode(rowData?.fieldListCode);
            //     },
            //   },
            // ]}
            options={{
              search: false,
              pageSize: rows,
              selection: StepperFieldList,
              toolbarButtonAlignment: 'left',
              selectionProps: handleSelectionProps,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={
              StepperFieldList ?
                [] :
                [
                  {
                    icon: () => <SaveIcon />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => console.log(rowData, 'rowData'),
                  },
                ]
            }
            components={{
              Pagination: (props) => (
                // Added Download Configuration Buttons in Table Pagination (2700799562)
                <div className="global-field-table-footer pagination-block">
                  {/* letter we removed that one */}
                  {StepperFieldList && <div className="mt-2"></div>}
                  {!StepperFieldList && (
                    <div className="mt-2">
                      {
                        <>
                          {!AuditFieldList && (
                            <Button
                              type="button"
                              variant="outlined"
                              className={`mx-1 search-btn`}
                              disabled={Boolean(dataCount === 0)}
                              onClick={(event) => {
                                const data = AuditFieldList ?
                                  {...auditSearchData} :
                                  {...searchData};
                                dispatch(
                                  postPrintUsage({
                                    baseCategory: data?.baseCategory?.categoryCode ?
                                      data?.baseCategory?.categoryCode :
                                      '',
                                    code: data?.fieldListCode ? data.fieldListCode : '',
                                    description: data?.fieldListDescripton ?
                                      data?.fieldListDescripton :
                                      '',
                                    displayName: '',
                                    fileType: '',
                                    recordFormatType: '',
                                    returnType: '',
                                    sourceType: 'FIELD LIST',
                                    search: printSearch ? printSearch : '',
                                    frameworkUsageOrderBy: '',
                                    frameworkUsageOrderDerection: '',
                                    fieldListOrderBy:
                                      queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                        queryRef.current.orderBy.field :
                                        '',
                                    fieldListOrderDerection: queryRef.current?.orderDirection ?
                                      queryRef.current?.orderDirection :
                                      '',
                                    category: '',
                                    fieldName: '',
                                    isDraft: '',
                                    repositoryDescription: '',
                                    repositoryName: '',
                                    repositoryType: '',
                                    tabType: AuditFieldList ? 'AuditField' : 'Global',
                                  }),
                                );
                              }}
                            >
                              Download Configuration Usage
                            </Button>
                          )}
                          <Button
                            type="button"
                            variant="outlined"
                            className={`mx-1 search-btn`}
                            disabled={Boolean(dataCount === 0)}
                            onClick={(event) => {
                              const data = AuditFieldList ?
                                {...auditSearchData} :
                                {...searchData};
                              dispatch(
                                printGlobalFieldList(
                                  {
                                    baseCategory: data?.baseCategory?.categoryCode ?
                                      data?.baseCategory?.categoryCode :
                                      '',
                                    fieldListCode: data?.fieldListCode ? data.fieldListCode : '',
                                    fieldListDesc: data?.fieldListDescripton ?
                                      data.fieldListDescripton :
                                      '',
                                    search: printSearch ? printSearch : '',
                                    orderBy:
                                      queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                        queryRef.current.orderBy.field :
                                        '',
                                    orderDirection: queryRef.current?.orderDirection ?
                                      queryRef.current?.orderDirection :
                                      '',
                                    tabType: AuditFieldList ? 'AuditField' : 'Global',
                                  },
                                  AuditFieldList,
                                ),
                              );
                            }}
                          >
                            {downloadButton}
                          </Button>
                        </>
                      }
                    </div>
                  )}
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleUsage={handleUsage}
                  // handleRun={handleRun}
                  // handleExecution={handleExecution}
                  handleCopy={handleCopy}
                  hiddenMenu={{
                    edit: StepperFieldList,
                    run: true,
                    copy: false,
                    delete: StepperFieldList,
                    notes: StepperFieldList,
                    execution: true,
                    usage: StepperFieldList || AuditFieldList,
                    user: true,
                    test: true,
                    password: true,
                  }}
                  disableMenu={{
                    disableEdit: !disable?.edit,
                    disableCopy: !disable?.add,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableRun: false,
                    disableTest: false,
                    disableDelete: !disable?.delete || disbaleRow?.isDefault === 'Y',
                    disableExecution: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    <Button
                      type="button"
                      variant="outlisetOpenned"
                      className={`mx-1 search-btn`}
                      disabled={disable?.add === false}
                      //  disabled: !disable?.add,
                      isFreeAction={true}
                      onClick={(event) => {
                        if (StepperFieldList) {
                          dispatch(resetMessage());
                          setShowSearch(true);
                        } else {
                          setTabValue(1);
                        }
                      }}
                      startIcon={<AddIcon />}
                    >
                      {AuditFieldList ? 'Add Audit Field List' : 'Add Field List'}
                    </Button>
                  </div>
                </div>
              ),
            }}
          />
        </div>
        {loading && <PageLoader />}
        {(errorMsg || deleteErrorMsg || printusage?.errorMsg) && (
          <ErrorSnackbar errorMsg={errorMsg || printusage?.errorMsg || deleteErrorMsg} />
        )}
        {(successMsg || printusage?.successMsg || tstmsg) && (
          <SuccessSnackbar successMsg={successMsg || printusage?.successMsg || tstmsg} />
        )}
      </Grid>
    </>
  );
};

export default FieldListSearchTable;
